<template>
    <div class="navigation-wrapper clearfix">
        <ul class="navigation clearfix">
            <li v-for="(link,index) in links" v-bind:key="'link_' + index">
                <router-link :to="link.url" v-if="link.type == 'link'" v-html="link.label"></router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'Navigation',
        props: ['links'],
        data: function () {
            return {};
        },
        computed: {
        },
        methods: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .navigation-wrapper {
        max-width: 1920px;
        margin: 0 auto;
        padding: 10px;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(0,0,0,0.8);
        z-index: 1;
        width: 100%;
    }

    .navigation {
        list-style: none;
        padding: 0;
        margin: 0;
    }

        .navigation li {
            float: left;
            padding: 5px 10px;
            font-weight: bold;
            font-size: 18px;
        }

    .router-link-exact-active {
        text-decoration: underline;
    }
</style>
